import { useEffect, useState } from 'react';
import { useSubscriptionStore } from '../../stores/subscription.store';
import { useCelebrationStore } from '../../stores/celebration.store';
import { useTrialModalStore } from '../../stores/trial-modal.store';
import TrialCountdownModal from './TrialCountdownModal';
import TrialExpiredModal from './TrialExpiredModal';
import SubscriptionModal from '../SubscriptionModal';

const TrialModals = () => {
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  // Dev console helpers (dev only, with cleanup — idempotent, safe in strict mode)
  useEffect(() => {
    if (!import.meta.env.DEV) return;

    const w = window as unknown as Record<string, unknown>;
    w.showTrialCountdown = (days = 2) => {
      useTrialModalStore.setState({ activeModal: 'countdown', daysRemaining: days });
      console.log(`[Dev] Showing trial countdown modal (${days} days remaining)`);
    };
    w.showTrialExpired = () => {
      useTrialModalStore.setState({ activeModal: 'expired', daysRemaining: 0 });
      console.log('[Dev] Showing trial expired modal');
    };
    w.hideTrialModal = () => {
      useTrialModalStore.setState({ activeModal: null, daysRemaining: null });
      console.log('[Dev] Trial modal hidden');
    };

    return () => {
      delete w.showTrialCountdown;
      delete w.showTrialExpired;
      delete w.hideTrialModal;
    };
  }, []);

  const subscription = useSubscriptionStore((s) => s.subscription);
  const plan = useSubscriptionStore((s) => s.plan);
  const celebrationIsOpen = useCelebrationStore((s) => s.isOpen);
  const activeModal = useTrialModalStore((s) => s.activeModal);
  const daysRemaining = useTrialModalStore((s) => s.daysRemaining);
  const evaluateTrialStatus = useTrialModalStore((s) => s.evaluateTrialStatus);
  const dismissCountdown = useTrialModalStore((s) => s.dismissCountdown);
  const dismissExpired = useTrialModalStore((s) => s.dismissExpired);

  // Evaluate trial status when subscription data or celebration state changes
  useEffect(() => {
    evaluateTrialStatus({ subscription, plan, celebrationIsOpen });
  }, [subscription, plan, celebrationIsOpen, evaluateTrialStatus]);

  const handleUpgrade = () => {
    if (activeModal === 'countdown') {
      dismissCountdown();
    } else {
      dismissExpired();
    }
    setShowSubscriptionModal(true);
  };

  return (
    <>
      <TrialCountdownModal
        isOpen={activeModal === 'countdown'}
        daysRemaining={daysRemaining ?? 0}
        onDismiss={dismissCountdown}
        onUpgrade={handleUpgrade}
      />

      <TrialExpiredModal
        isOpen={activeModal === 'expired'}
        onDismiss={dismissExpired}
        onSubscribe={handleUpgrade}
      />

      {/* Raised over whatever page is open: at Z_DIALOG, over its bottom nav. */}
      <SubscriptionModal
        isOpen={showSubscriptionModal}
        onClose={() => setShowSubscriptionModal(false)}
      />
    </>
  );
};

export default TrialModals;
